import React from 'react';
import { Typography } from 'antd';
import SealApprovalAttachmentsView from '../Admin/SealApprovalAttachmentsView';
import {
  PrepaymentBasicInfoReadonly,
  PrepaymentPayeeReadonly,
  PrepaymentLinesReadonly,
  resolveApplicantDeptDisplay
} from './PrepaymentReadonlyInfo';
import { prepaymentTotalSummaryLabel } from '../../utils/prepaymentDocTypeLabels';
import './ExpenseClaimForm.css';

const { Text } = Typography;

function formatAmount(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `¥${num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function PrepaymentApplicationReadonlyView({
  formData = {},
  organizations = [],
  applicantPrepaymentSummary
}) {
  const otherAttachments = formData.other_attachments || [];
  const applicantDeptName = resolveApplicantDeptDisplay(formData, organizations);

  return (
    <div className="process-form-finance-grouped">
      {formData.subject && (
        <div className="process-form-finance-summary">
          <div className="process-form-finance-summary-subject">{formData.subject}</div>
          <div className="process-form-finance-summary-grid">
            {formData.applicant_name && (
              <div className="process-form-finance-summary-item">
                <Text type="secondary">申请人</Text>
                <span>
                  {formData.applicant_name}
                  {formData.applicant_dept_name ? ` · ${formData.applicant_dept_name}` : ''}
                </span>
              </div>
            )}
            {formData.prepay_total != null && formData.prepay_total !== '' && (
              <div className="process-form-finance-summary-item process-form-finance-summary-amount">
                <Text type="secondary">{prepaymentTotalSummaryLabel(formData.doc_type)}</Text>
                <span>{formatAmount(formData.prepay_total)}</span>
              </div>
            )}
            {formData.prepay_total_uppercase && (
              <div className="process-form-finance-summary-item">
                <Text type="secondary">金额大写</Text>
                <span>{formData.prepay_total_uppercase}</span>
              </div>
            )}
          </div>
        </div>
      )}

      <PrepaymentBasicInfoReadonly
        formData={formData}
        organizations={organizations}
        sectionSuffix=""
        applicantPrepaymentSummary={applicantPrepaymentSummary}
      />
      <PrepaymentPayeeReadonly formData={formData} sectionSuffix="" />
      <PrepaymentLinesReadonly
        formData={formData}
        organizations={organizations}
        variant="application"
        sectionSuffix=""
      />

      {(otherAttachments.length > 0 || formData.remark) && (
        <section className="expense-claim-section">
          <div className="expense-claim-section-title">附件与备注</div>
          {otherAttachments.length > 0 && (
            <div className="process-form-snapshot-attachments" style={{ marginBottom: 12 }}>
              <SealApprovalAttachmentsView attachments={otherAttachments} title="其他附件" />
            </div>
          )}
          {formData.remark && (
            <div className="prepayment-readonly-item">
              <Text type="secondary" className="prepayment-readonly-label">备注</Text>
              <div className="prepayment-readonly-value">{formData.remark}</div>
            </div>
          )}
        </section>
      )}
    </div>
  );
}
